import styled from 'styled-components';
import { Typography } from '../Typography/Typography.styled';

/** h2 visualmente compacto — AccessMonitor hx_01b / hierarquia após PageTitle. */
export const Heading = styled(Typography.Title).attrs({ level: 2 })`
  && {
    color: ${({ color }) => color};
    font-weight: bold;
    font-size: ${({ theme }) => `${14 + 2 * theme.zoomFonte}px`};
    line-height: 1.4;
    display: block;
    width: fit-content;
    max-width: 100%;
    padding: 2px 6px;
    margin: 0 0 8px -6px;
    border-radius: 4px;
    background-color: #f5f5f5;
    text-shadow: none;
  }
`;
